export default __webpack_public_path__ + "static/media/logo.ade19709.svg";